<div class="container" [ngClass]="placement$ | async" [class.impaired]="impaired$ | async">
	@for (msg of notificationService.floatingMessages$ | async; track msg; let i = $index) {
		<app-floatingitem [item]="msg" [index]="i"></app-floatingitem>
	}
</div>
